import React from 'react';
import QuestionLabel from './QuestionLabel';
import { FormPart, part } from '~/lib/FormCssApi';

const BigtextQuestion = ({ label, value, setValue, settings }) => {
    return (
        <label>
            <QuestionLabel label={label} settings={settings} />
            <div {...part(FormPart.CONTROL)}>
                <textarea
                    {...part(FormPart.INPUT)}
                    value={value}
                    onChange={e => setValue(e.target.value)}
                    className="max-w-full min-h-32"
                />
            </div>
        </label>
    );
};

export default BigtextQuestion;
